export const KITCHEN = {
  GET_DATA_KITCHEN_SUCCESS: "GET_DATA_KITCHEN_SUCCESS",
  LOADING_DATA_KITCHEN_SUCCESS: "LOADING_DATA_KITCHEN_SUCCESS",
};

export const LOCATIONS = {
  GET_DATA_LOCATION_SUCCESS: "GET_DATA_LOCATION_SUCCESS",
  LOADING_DATA_LOCATION_SUCCESS: "LOADING_DATA_LOCATION_SUCCESS",
  LOADING_POST_LOCATION_SUCCESS: "LOADING_POST_LOCATION_SUCCESS",

  GET_DATA_LOCATION_POINT_SUCCESS: "GET_DATA_LOCATION_POINT_SUCCESS",
  LOADING_DATA_LOCATION_POINT_SUCCESS: "LOADING_DATA_LOCATION_POINT_SUCCESS",
  LOADING_POST_LOCATION_POINT_SUCCESS: "LOADING_POST_LOCATION_POINT_SUCCESS",

  GET_DATA_LOCATION_FEE_SUCCESS: "GET_DATA_LOCATION_FEE_SUCCESS",
  LOADING_DATA_LOCATION_FEE_SUCCESS: "LOADING_DATA_LOCATION_FEE_SUCCESS",
  LOADING_POST_LOCATION_FEE_SUCCESS: "LOADING_POST_LOCATION_FEE_SUCCESS",
};

export const BANKS = {
  GET_DATA_BANKS_SUCCESS: "GET_DATA_BANKS_SUCCESS",
  LOADING_DATA_BANKS_SUCCESS: "LOADING_DATA_BANKS_SUCCESS",
};

export const CASHIER = {
  GET_DATA_CASHIER_SUCCESS: "GET_DATA_CASHIER_SUCCESS",
  LOADING_DATA_CASHIER_SUCCESS: "LOADING_DATA_CASHIER_SUCCESS",
  LOADING_POST_CASHIER_SUCCESS: "LOADING_POST_CASHIER_SUCCESS",
};

export const VOUCHER = {
  GET_DATA_VOUCHER_SUCCESS: "GET_DATA_VOUCHER_SUCCESS",
  LOADING_DATA_VOUCHER_SUCCESS: "LOADING_DATA_VOUCHER_SUCCESS",
  LOADING_POST_VOUCHER_SUCCESS: "LOADING_POST_VOUCHER_SUCCESS",
};

export const DEALER = {
  GET_DATA_DEALER_SUCCESS: "GET_DATA_DEALER_SUCCESS",
  LOADING_DATA_DEALER_SUCCESS: "LOADING_DATA_DEALER_SUCCESS",
  LOADING_POST_DEALER_SUCCESS: "LOADING_POST_DEALER_SUCCESS",
};

export const VERIFIKASI_USER = {
  GET_DATA_VERIFIKASI_USER_SUCCESS: "GET_DATA_VERIFIKASI_USER_SUCCESS",
  LOADING_DATA_VERIFIKASI_USER_SUCCESS: "LOADING_DATA_VERIFIKASI_USER_SUCCESS",
  LOADING_POST_VERIFIKASI_USER_SUCCESS: "LOADING_POST_VERIFIKASI_USER_SUCCESS",
};

export const REKAP_TRANSAKSI = {
  GET_DATA_REKAP_TRANSAKSI_USER_SUCCESS:
    "GET_DATA_REKAP_TRANSAKSI_USER_SUCCESS",
  LOADING_DATA_REKAP_TRANSAKSI_USER_SUCCESS:
    "LOADING_DATA_REKAP_TRANSAKSI_USER_SUCCESS",
  DOWNLOAD_DANA_POTONGAN: "DOWNLOAD_DANA_POTONGAN",
  LOADING_DOWNLOAD_DANA_POTONGAN: "LOADING_DOWNLOAD_DANA_POTONGAN",
};

export const SIMPANAN_SUKARELA = {
  GET_DATA_SIMPANAN_SUKARELA_SUCCESS: "GET_DATA_SIMPANAN_SUKARELA_SUCCESS",
  LOADING_DATA_SIMPANAN_SUKARELA_SUCCESS:
    "LOADING_DATA_SIMPANAN_SUKARELA_SUCCESS",

  LOADING_ACTION_SIMPANAN_SUKARELA: "LOADING_ACTION_SIMPANAN_SUKARELA",
  IS_MODAL_ACTION_SIMPANAN_SUKARELA: "IS_MODAL_ACTION_SIMPANAN_SUKARELA",
  SET_QUERY_KEY: "SUKARELA_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "SUKARELA_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "SUKARELA_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "SUKARELA_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "SUKARELA_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "SUKARELA_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "SUKARELA_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "SUKARELA_UPDATE_CACHE_ITEMS",
};

export const SIMPANAN_INVESTASI = {
  GET_DATA_SIMPANAN_INVESTASI_SUCCESS: "GET_DATA_SIMPANAN_INVESTASI_SUCCESS",
  LOADING_DATA_SIMPANAN_INVESTASI_SUCCESS:
    "LOADING_DATA_SIMPANAN_INVESTASI_SUCCESS",

  LOADING_ACTION_SIMPANAN_INVESTASI: "LOADING_ACTION_SIMPANAN_INVESTASI",
  IS_MODAL_ACTION_SIMPANAN_INVESTASI: "IS_MODAL_ACTION_SIMPANAN_INVESTASI",
  SET_QUERY_KEY: "INVESTASI_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "INVESTASI_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "INVESTASI_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "INVESTASI_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "INVESTASI_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "INVESTASI_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "INVESTASI_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "INVESTASI_UPDATE_CACHE_ITEMS",
};

export const SIMPANAN_BERJANGKA = {
  GET_DATA_SIMPANAN_BERJANGKA_SUCCESS: "GET_DATA_SIMPANAN_BERJANGKA_SUCCESS",
  LOADING_DATA_SIMPANAN_BERJANGKA_SUCCESS:
    "LOADING_DATA_SIMPANAN_BERJANGKA_SUCCESS",

  LOADING_ACTION_SIMPANAN_BERJANGKA: "LOADING_ACTION_SIMPANAN_BERJANGKA",
  IS_MODAL_ACTION_SIMPANAN_BERJANGKA: "IS_MODAL_ACTION_SIMPANAN_BERJANGKA",
  SET_QUERY_KEY: "BERJANGKA_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "BERJANGKA_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "BERJANGKA_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "BERJANGKA_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "BERJANGKA_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "BERJANGKA_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "BERJANGKA_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "BERJANGKA_UPDATE_CACHE_ITEMS",
};

export const SIMPANAN_HIBAH = {
  GET_DATA_SIMPANAN_HIBAH_SUCCESS: "GET_DATA_SIMPANAN_HIBAH_SUCCESS",
  LOADING_DATA_SIMPANAN_HIBAH_SUCCESS: "LOADING_DATA_SIMPANAN_HIBAH_SUCCESS",

  LOADING_ACTION_SIMPANAN_HIBAH: "LOADING_ACTION_SIMPANAN_HIBAH",
  IS_MODAL_ACTION_SIMPANAN_HIBAH: "IS_MODAL_ACTION_SIMPANAN_HIBAH",
  SET_QUERY_KEY: "HIBAH_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "HIBAH_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "HIBAH_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "HIBAH_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "HIBAH_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "HIBAH_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "HIBAH_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "HIBAH_UPDATE_CACHE_ITEMS",
};

export const PENGATURAN_SIMPANAN_SUMMARY = {
  GET_DATA_PENGATURAN_SIMPANAN_SUCCESS: "GET_DATA_PENGATURAN_SIMPANAN_SUCCESS",
  LOADING_DATA_PENGATURAN_SIMPANAN_SUCCESS:
    "LOADING_DATA_PENGATURAN_SIMPANAN_SUCCESS",

  SET_QUERY_KEY: "PENGATURAN_SIMPANAN_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "PENGATURAN_SIMPANAN_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "PENGATURAN_SIMPANAN_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "PENGATURAN_SIMPANAN_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "PENGATURAN_SIMPANAN_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "PENGATURAN_SIMPANAN_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "PENGATURAN_SIMPANAN_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "PENGATURAN_SIMPANAN_UPDATE_CACHE_ITEMS",
};

export const PENGATURAN_SIMPANAN_MONTHLY = {
  GET_DATA_PENGATURAN_SIMPANAN_MONTHLY_SUCCESS:
    "GET_DATA_PENGATURAN_SIMPANAN_MONTHLY_SUCCESS",
  LOADING_DATA_PENGATURAN_SIMPANAN_MONTHLY_SUCCESS:
    "LOADING_DATA_PENGATURAN_SIMPANAN_MONTHLY_SUCCESS",

  SET_QUERY_KEY: "PENGATURAN_SIMPANAN_MONTHLY_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "PENGATURAN_SIMPANAN_MONTHLY_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "PENGATURAN_SIMPANAN_MONTHLY_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "PENGATURAN_SIMPANAN_MONTHLY_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "PENGATURAN_SIMPANAN_MONTHLY_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "PENGATURAN_SIMPANAN_MONTHLY_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "PENGATURAN_SIMPANAN_MONTHLY_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "PENGATURAN_SIMPANAN_MONTHLY_UPDATE_CACHE_ITEMS",
};

export const TEMPORARY_REGISTRATION_ADMIN = {
  GET_DATA_TEMPORARY_REGISTRATION_SUCCESS:
    "GET_DATA_TEMPORARY_REGISTRATION_SUCCESS",
  LOADING_DATA_TEMPORARY_REGISTRATION_SUCCESS:
    "LOADING_DATA_TEMPORARY_REGISTRATION_SUCCESS",
  LOADING_ACTION_TEMPORARY_REGISTRATION:
    "LOADING_ACTION_TEMPORARY_REGISTRATION",
};
export const PENGATURAN_SIMPANAN_SUKARELA = {
  GET_DATA_PENGATURAN_SUKARELA_SUCCESS: "GET_DATA_PENGATURAN_SUKARELA_SUCCESS",
  LOADING_DATA_PENGATURAN_SUKARELA_SUCCESS:
    "LOADING_DATA_PENGATURAN_SUKARELA_SUCCESS",

  LOADING_ACTION_PENGATURAN_SUKARELA: "LOADING_ACTION_PENGATURAN_SUKARELA",
  IS_MODAL_ACTION_PENGATURAN_SUKARELA: "IS_MODAL_ACTION_PENGATURAN_SUKARELA",

  SET_QUERY_KEY: "PENGATURAN_SUKARELA_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "PENGATURAN_SUKARELA_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "PENGATURAN_SUKARELA_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "PENGATURAN_SUKARELA_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "PENGATURAN_SUKARELA_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "PENGATURAN_SUKARELA_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "PENGATURAN_SUKARELA_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "PENGATURAN_SUKARELA_UPDATE_CACHE_ITEMS",
  UPDATE_SUKARELA_RESET: "UPDATE_SUKARELA_RESET",
  UPDATE_SUKARELA_SUCCESS: "UPDATE_SUKARELA_SUCCESS",
};

export const PENGATURAN_SIMPANAN_BERJANGKA = {
  GET_DATA_PENGATURAN_BERJANGKA_SUCCESS: "GET_DATA_PENGATURAN_BERJANGKA_SUCCESS",
  LOADING_DATA_PENGATURAN_BERJANGKA_SUCCESS:
    "LOADING_DATA_PENGATURAN_BERJANGKA_SUCCESS",

  LOADING_ACTION_PENGATURAN_BERJANGKA: "LOADING_ACTION_PENGATURAN_BERJANGKA",
  IS_MODAL_ACTION_PENGATURAN_BERJANGKA: "IS_MODAL_ACTION_PENGATURAN_BERJANGKA",

  SET_QUERY_KEY: "PENGATURAN_BERJANGKA_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "PENGATURAN_BERJANGKA_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "PENGATURAN_BERJANGKA_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "PENGATURAN_BERJANGKA_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "PENGATURAN_BERJANGKA_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "PENGATURAN_BERJANGKA_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "PENGATURAN_BERJANGKA_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "PENGATURAN_BERJANGKA_UPDATE_CACHE_ITEMS",
  UPDATE_BERJANGKA_RESET: "UPDATE_BERJANGKA_RESET",
  UPDATE_BERJANGKA_SUCCESS: "UPDATE_BERJANGKA_SUCCESS",
};

export const ADD_SIMPANAN_WAJIB = {
  GET_DATA_SIMPANAN_WAJIB_SUCCESS: "GET_DATA_SIMPANAN_WAJIB_SUCCESS",
  LOADING_DATA_SIMPANAN_WAJIB_SUCCESS: "LOADING_DATA_SIMPANAN_WAJIB_SUCCESS",
  ADD_SELECTED_IDS: "SIMPANAN_WAJIB_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "SIMPANAN_WAJIB_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "SIMPANAN_WAJIB_CLEAR_SELECTED_IDS",

  LOADING_ACTION_SIMPANAN_WAJIB: "LOADING_ACTION_SIMPANAN_WAJIB",
  IS_MODAL_ACTION_SIMPANAN_WAJIB: "IS_MODAL_ACTION_SIMPANAN_WAJIB",

  SET_QUERY_KEY: "SIMPANAN_WAJIB_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "SIMPANAN_WAJIB_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "SIMPANAN_WAJIB_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "SIMPANAN_WAJIB_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "SIMPANAN_WAJIB_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "SIMPANAN_WAJIB_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "SIMPANAN_WAJIB_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "SIMPANAN_WAJIB_UPDATE_CACHE_ITEMS",
  SIMPANAN_WAJIB_RESET: "SIMPANAN_WAJIB_RESET",
  SIMPANAN_WAJIB_SUCCESS: "SIMPANAN_WAJIB_SUCCESS",
}

export const ADD_SIMPANAN_POKOK = {
  GET_DATA_SIMPANAN_POKOK_SUCCESS: "GET_DATA_SIMPANAN_POKOK_SUCCESS",
  LOADING_DATA_SIMPANAN_POKOK_SUCCESS: "LOADING_DATA_SIMPANAN_POKOK_SUCCESS",
  ADD_SELECTED_IDS: "SIMPANAN_POKOK_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "SIMPANAN_POKOK_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "SIMPANAN_POKOK_CLEAR_SELECTED_IDS",

  LOADING_ACTION_SIMPANAN_POKOK: "LOADING_ACTION_SIMPANAN_POKOK",
  IS_MODAL_ACTION_SIMPANAN_POKOK: "IS_MODAL_ACTION_SIMPANAN_POKOK",

  SET_QUERY_KEY: "SIMPANAN_POKOK_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "SIMPANAN_POKOK_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "SIMPANAN_POKOK_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "SIMPANAN_POKOK_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "SIMPANAN_POKOK_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "SIMPANAN_POKOK_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "SIMPANAN_POKOK_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "SIMPANAN_POKOK_UPDATE_CACHE_ITEMS",
  SIMPANAN_POKOK_RESET: "SIMPANAN_POKOK_RESET",
  SIMPANAN_POKOK_SUCCESS: "SIMPANAN_POKOK_SUCCESS",
}

export const ADD_SUKARELA = {
  GET_DATA_SUKARELA_SUCCESS: "GET_DATA_SUKARELA_SUCCESS",
  LOADING_DATA_SUKARELA_SUCCESS: "LOADING_DATA_SUKARELA_SUCCESS",
  ADD_SELECTED_IDS: "SUKARELA_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "SUKARELA_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "SUKARELA_CLEAR_SELECTED_IDS",

  LOADING_ACTION_SUKARELA: "LOADING_ACTION_SUKARELA",
  IS_MODAL_ACTION_SUKARELA: "IS_MODAL_ACTION_SUKARELA",

  SET_QUERY_KEY: "SUKARELA_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "SUKARELA_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "SUKARELA_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "SUKARELA_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "SUKARELA_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "SUKARELA_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "SUKARELA_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "SUKARELA_UPDATE_CACHE_ITEMS",
  SUKARELA_RESET: "SUKARELA_RESET",
  SUKARELA_SUCCESS: "SUKARELA_SUCCESS",
}

export const ADD_BERJANGKA = {
  GET_DATA_BERJANGKA_SUCCESS: "GET_DATA_BERJANGKA_SUCCESS",
  LOADING_DATA_BERJANGKA_SUCCESS: "LOADING_DATA_BERJANGKA_SUCCESS",
  ADD_SELECTED_IDS: "BERJANGKA_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "BERJANGKA_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "BERJANGKA_CLEAR_SELECTED_IDS",

  LOADING_ACTION_BERJANGKA: "LOADING_ACTION_BERJANGKA",
  IS_MODAL_ACTION_BERJANGKA: "IS_MODAL_ACTION_BERJANGKA",

  SET_QUERY_KEY: "BERJANGKA_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "BERJANGKA_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "BERJANGKA_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "BERJANGKA_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "BERJANGKA_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "BERJANGKA_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "BERJANGKA_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "BERJANGKA_UPDATE_CACHE_ITEMS",
  BERJANGKA_RESET: "BERJANGKA_RESET",
  BERJANGKA_SUCCESS: "BERJANGKA_SUCCESS",
}

export const ADD_INVESTASI = {
  GET_DATA_INVESTASI_SUCCESS: "GET_DATA_INVESTASI_SUCCESS",
  LOADING_DATA_INVESTASI_SUCCESS: "LOADING_DATA_INVESTASI_SUCCESS",
  ADD_SELECTED_IDS: "INVESTASI_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "INVESTASI_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "INVESTASI_CLEAR_SELECTED_IDS",

  LOADING_ACTION_INVESTASI: "LOADING_ACTION_INVESTASI",
  IS_MODAL_ACTION_INVESTASI: "IS_MODAL_ACTION_INVESTASI",

  SET_QUERY_KEY: "INVESTASI_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "INVESTASI_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "INVESTASI_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "INVESTASI_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "INVESTASI_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "INVESTASI_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "INVESTASI_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "INVESTASI_UPDATE_CACHE_ITEMS",
  INVESTASI_RESET: "INVESTASI_RESET",
  INVESTASI_SUCCESS: "INVESTASI_SUCCESS",
}

export const ADD_HIBAH = {
  GET_DATA_HIBAH_SUCCESS: "GET_DATA_HIBAH_SUCCESS",
  LOADING_DATA_HIBAH_SUCCESS: "LOADING_DATA_HIBAH_SUCCESS",
  ADD_SELECTED_IDS: "HIBAH_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "HIBAH_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "HIBAH_CLEAR_SELECTED_IDS",

  LOADING_ACTION_HIBAH: "LOADING_ACTION_HIBAH",
  IS_MODAL_ACTION_HIBAH: "IS_MODAL_ACTION_HIBAH",

  SET_QUERY_KEY: "HIBAH_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "HIBAH_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "HIBAH_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "HIBAH_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "HIBAH_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "HIBAH_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "HIBAH_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "HIBAH_UPDATE_CACHE_ITEMS",
  HIBAH_RESET: "HIBAH_RESET",
  HIBAH_SUCCESS: "HIBAH_SUCCESS",
}

export const KLIKOO_PRODUCT = {
  GET_DATA_KLIKOO_PRODUCT_SUCCESS: "GET_DATA_KLIKOO_PRODUCT_SUCCESS",
  LOADING_DATA_KLIKOO_PRODUCT_SUCCESS: "LOADING_DATA_KLIKOO_PRODUCT_SUCCESS",
  LOADING_POST_KLIKOO_PRODUCT_SUCCESS: "LOADING_POST_KLIKOO_PRODUCT_SUCCESS",
  GET_CATEGORIES_KLIKOO_PRODUCT_SUCCESS: "GET_CATEGORIES_KLIKOO_PRODUCT_SUCCESS",
};

export const FEE_KLIKOO = {
  GET_DATA_FEE_KLIKOO_SUCCESS: "GET_DATA_FEE_KLIKOO_SUCCESS",
  LOADING_DATA_FEE_KLIKOO_SUCCESS: "LOADING_DATA_FEE_KLIKOO_SUCCESS",
  LOADING_POST_FEE_KLIKOO_SUCCESS: "LOADING_POST_FEE_KLIKOO_SUCCESS",
};

export const PINJAMAN = {
  GET_DATA_PINJAMAN_SUCCESS: "GET_DATA_PINJAMAN_SUCCESS",
  LOADING_DATA_PINJAMAN_SUCCESS: "LOADING_DATA_PINJAMAN_SUCCESS",
  ADD_SELECTED_IDS: "PINJAMAN_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "PINJAMAN_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "PINJAMAN_CLEAR_SELECTED_IDS",

  LOADING_ACTION_PINJAMAN: "LOADING_ACTION_PINJAMAN",
  IS_MODAL_ACTION_PINJAMAN: "IS_MODAL_ACTION_PINJAMAN",

  SET_QUERY_KEY: "PINJAMAN_SET_QUERY_KEY",
  ADD_SELECTED_IDS: "PINJAMAN_ADD_SELECTED_IDS",
  REMOVE_SELECTED_IDS: "PINJAMAN_REMOVE_SELECTED_IDS",
  CLEAR_SELECTED_IDS: "PINJAMAN_CLEAR_SELECTED_IDS",

  SET_CACHE_ENTRY: "PINJAMAN_SET_CACHE_ENTRY",
  SET_LOADING_FOR_KEY: "PINJAMAN_SET_LOADING_FOR_KEY",
  INVALIDATE_CACHE_KEYS: "PINJAMAN_INVALIDATE_CACHE_KEYS",
  UPDATE_CACHE_ITEMS: "PINJAMAN_UPDATE_CACHE_ITEMS",
  PINJAMAN_RESET: "PINJAMAN_RESET",
  PINJAMAN_SUCCESS: "PINJAMAN_SUCCESS",
}